"use-strict";

import 'jquery';

import { Alert } from './Alert';
import { Anchors } from './Anchors';
// import { Carrosel } from './Carrosel';
// import { Fancybox } from './Fancybox';
import { Form } from './Form';
import { Helpers } from './Helpers';
import { Lazy } from './Lazy';
import { Menu } from './Menu';
import { MobileDetect } from './MobileDetect';
import { Modal } from './Modal';
import { Scroll } from './Scroll';
import { Token } from './Token';


/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


//fix para o fancybox.
//o $.browser foi removido da versao 1.9 do jQuery
$.browser = {};

window.app = window.app || {};

//https://fancyapps.com/fancybox/3/
// require('./../assets/plugins/fancybox/jquery.fancybox.min');

window.app.initialize = () => {
    try{
        window.app.Menu = new Menu;
    } catch (e) {console.log('Menu.e: ', e);}

    try {
        window.app.Scroll = new Scroll;
    } catch (e) { console.log('Scroll.e: ', e); }

    try {
        window.app.Anchors = new Anchors;
    } catch (e) {console.log('Anchors.e: ', e);}

    try{
        window.app.MobileDetect = new MobileDetect;
    }catch (e) { console.log('MobileDetect.e: ', e);}

    try{
        window.app.Lazy = new Lazy;
    }catch (e) { console.log('Lazy.e: ', e);}

    try{
        window.app.Helpers = new Helpers;
    }catch (e) { console.log('Helpers.e: ', e);}

    // try {
    //     // window.app.Carrosel = new Carrosel;
    // } catch (e) { console.log('Carousel.e: ', e); }

    try{
        window.app.alert = new Alert;
    }catch (e) { console.log('Alert.e: ', e);}

    try{
        window.app.Token = new Token;
    }catch (e) { console.log('Token.e: ', e);}

    try{
        window.app.Form = new Form;
    }catch (e) { console.log('Form.e: ', e);}

    try{
        window.app.modal = new Modal;
    }catch (e) { console.log('Modal.e: ', e);}

    // try {
    //     window.app.Fancybox = new Fancybox;
    // } catch (e) {console.log('Fancy.e: ', e);}
};

// $(document).ready(() => {
//     const spin = document.getElementById('spinner');

//     console.log('spin', spin);
//     if (spin && spin.classList.contains('spinner--open')) {
//         setTimeout(() => {
//             spin.classList.remove('spinner--open');
//         }, 600)
//     }
// })

window.app.initialize();
